import { Icon } from "@/components/ui/icon";

import { useSpinner, UseSpinnerProps } from "./use-spinner";

export type SpinnerProps = UseSpinnerProps;

function Spinner(props: SpinnerProps) {
  const { className, styles } = useSpinner(props);

  return <Icon name="loader" className={styles.base({ className })} aria-hidden="true" />;
}

export default Spinner;
